import React, { useState } from 'react';
// material
import { makeStyles } from '@material-ui/core/styles';

interface IconSquareProps {
  icon: string;
  text: number;
}

const IconSquare: React.FC<IconSquareProps> = (props) => {

  const classes = useStyles({});

  return (
    <>
      <img src={props.icon} />
      <div className={classes.text}>{props.text}</div>
    </>
  )
};
export default IconSquare;

const useStyles = makeStyles(theme => ({
  container: {
    padding:5,
    width: 270,
    minHeight: 155,
  },
  subContainer: {
    padding: 20,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: 'white',
    borderRadius: 4,
    margin: 'auto'
  },
  iconContainer: {
    paddingTop: 13,
    paddingBottom: 20,
    textAlign: 'center'
  },
  text: {
    color: '#5A728F',
    fontFamily: 'Asap',
    fontSize: '16px',
    letterSpacing: 0,
    textAlign: 'center',
    marginTop:20
  }
}));


// WEBPACK FOOTER //
// ./src/pages/home/components/IconSquare.tsx